import { Button, FormControl, InputLabel, OutlinedInput, Stack, Typography, CircularProgress } from "@mui/material";
import * as React from "react";
import Modal, { CommonModalProps } from "..";
import { useTranslation } from "react-i18next";

export type ModalCreateAssetGroupElementProps = {
  hasSelection?: boolean;
  onConfirm: (groupName: string, closeModal: () => void, disableLoader: () => void) => void;
};

export type ModalCreateAssetGroupProps = CommonModalProps<ModalCreateAssetGroupElementProps>;

const ModalCreateAssetGroup = React.forwardRef<any, ModalCreateAssetGroupProps>((props, ref) => {
  const { hasSelection, onConfirm, closeModal } = props;
  const { t } = useTranslation();

  const [showLoader, setShowLoader] = React.useState(false);
  const [formValue, setFormValue] = React.useState("");

  const handleConfirm = React.useCallback(() => {
    setShowLoader(true);
    onConfirm(formValue, closeModal, () => setShowLoader(false));
  }, [onConfirm, formValue]);

  return (
    <Modal
      title={t("modal:title.nameYourGroup")}
      reference={ref}
      closeModal={closeModal}
      width={504}
      footer={
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button onClick={closeModal} disabled={showLoader}>
            {t("common:cancel")}
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleConfirm}
            disabled={formValue.length <= 0 || showLoader}
          >
            {showLoader ? <CircularProgress size={20} thickness={5} color="primary" /> : t("common:confirm")}
          </Button>
        </Stack>
      }
    >
      {hasSelection && (
        <Typography color="text.secondary" variant="subtitle2" fontWeight={400} mb={3}>
          {t("modal:modalCreateAssetGroup.subTitle")}
        </Typography>
      )}
      <FormControl>
        <InputLabel shrink htmlFor="folder-name">
          {t("field:label.groupName")}
        </InputLabel>
        <OutlinedInput
          placeholder={t("field:placeholder.folderName")}
          id="folder-name"
          value={formValue}
          onChange={(e) => setFormValue(e.currentTarget.value)}
          disabled={showLoader}
        />
      </FormControl>
    </Modal>
  );
});

export default ModalCreateAssetGroup;
